import api from './client';

export const uploadAvatar = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const res = await api.post('/auth/me/avatar', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const changePassword = async (current_password, new_password) => {
  const res = await api.patch('/auth/me/password', { current_password, new_password });
  return res.data;
};

export const changeEmail = async (new_email, current_password) => {
  const res = await api.patch('/auth/me/email', { new_email, current_password });
  return res.data;
};

export const verifyEmailOtp = async (otp) => {
  const res = await api.post('/auth/verify-email', { otp });
  return res.data;
};

export const resendOtp = async () => {
  const res = await api.post('/auth/verify-email/resend');
  return res.data;
};

// Alias kept for the EmailVerifyBanner (Phase 17)
export const resendVerificationOtp = resendOtp;

export const pauseAccount = async () => {
  const res = await api.post('/auth/me/pause');
  return res.data;
};

export const resumeAccount = async () => {
  const res = await api.post('/auth/me/resume');
  return res.data;
};

export const deleteAccount = async (current_password) => {
  const res = await api.delete('/auth/me', { data: { current_password } });
  return res.data;
};

// Social-only accounts (no local password): email OTP confirmation.
export const requestDeleteOtp = async () => {
  const res = await api.post('/auth/me/delete/request-otp');
  return res.data;
};

export const deleteAccountWithOtp = async (otp) => {
  const res = await api.delete('/auth/me', { data: { otp } });
  return res.data;
};

// Admin
export const adminPauseUser = async (userId) => {
  const res = await api.post(`/admin/users/${userId}/pause`);
  return res.data;
};
export const adminResumeUser = async (userId) => {
  const res = await api.post(`/admin/users/${userId}/resume`);
  return res.data;
};
// Giu 2026 — STANDBY (hidden from feeds, user can still log in/edit).
export const adminStandbyUser = async (userId, reason = '') => {
  const res = await api.post(`/admin/users/${userId}/standby`, { reason });
  return res.data;
};
export const adminReleaseStandby = async (userId) => {
  const res = await api.post(`/admin/users/${userId}/standby/release`);
  return res.data;
};
export const adminGetUserCard = async (userId) => {
  const res = await api.get(`/admin/users/${userId}/card`);
  return res.data;
};
export const adminDeleteUser = async (userId) => {
  const res = await api.delete(`/admin/users/${userId}`);
  return res.data;
};
